var m = require('mithril');
var systemDetail = require('./systemDetail');
var layout = require('../layout/layout');
// var permissions = require('./permissions');


routes = {
  '/system/:id': {
    view: function() {
      return m(layout, m(systemDetail));
    },
  },
  
  // '/system/:id/permissions': {
  //   view: function() {
  //     return m(layout, m(permissions));
  //   },
  // }
}


module.exports = routes;